import type { CSSProperties, FC, PropsWithChildren } from "react";

export type PageProps = {
    name?: string;
    style?: CSSProperties;
} & PropsWithChildren;

export const PageLayout: FC<PageProps> = ({ name, style, children }) => {
    return (
        <div data-name={name} style={style}>
            {children}
        </div>
    );
};
